import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button, IconButton, Tooltip, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box } from "@mui/system";
import { Close } from "@mui/icons-material";
import { ErrorAlert, SuccessAlert } from "../../utils/Alerts";
import AddConnectionPoints from "./AddConnectionPoints";
import {
  useDeleteConnectionMutation,
  useGetAllConnectionsQuery,
} from "../../Slices/roomNateApis";
import ViewConnection from "./ViewConnection";
import UpdateConnection from "./UpdateConnection";
import { baseUrl } from "../../utils/baseUrl";

export default function BasicTable({
  connectionPointsOptionsData,
  connectionPointsData,
  FetchItems,
}) {
  const [deleteConnection, resultStats] = useDeleteConnectionMutation();
  const {
    data: FetchConnections,
    isFetching,
  } = useGetAllConnectionsQuery();

  const [selectedId, setSelectedId] = React.useState();

  const [open, setOpen] = React.useState(false);

  const [successAlert, setSuccessAlert] = React.useState(false);
  const [errorAlert, setErrorAlert] = React.useState(false);

  const handleClickOpen = (id) => {
    setOpen(true);
    setSelectedId(id);
  };

  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    if (resultStats?.isSuccess) {
      setSuccessAlert(true);
      setTimeout(() => {
        setSuccessAlert(false);
      }, 2000);
    }

    if (resultStats?.isError) {
      setErrorAlert(true);
      setTimeout(() => {
        setErrorAlert(false);
      }, 2000);
    }
  }, [resultStats]);

  const handleDelete = (deleteItemIndex) => {
    handleClose();
    deleteConnection(selectedId);
    setOpen(false);
  };

  return (
    <>
      {successAlert && (
        <SuccessAlert title="Item has been deleted successfully!" />
      )}

      {errorAlert && <ErrorAlert title="Something Went Wrong!" />}

      <TableContainer component={Paper}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            py: 2,
            px: 2,
          }}
        >
          <Typography variant="h6" component={"h6"} flexGrow={1}>
            Connections
          </Typography>

          <AddConnectionPoints
            items={FetchItems}
            connectionPointsOptionsData={connectionPointsOptionsData}
            connectionPointsData={connectionPointsData}
          />
        </Box>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">Item 1 FrontImage</TableCell>
              <TableCell align="center">Item 1</TableCell>
              <TableCell align="center">Item 2 FrontImage</TableCell>
              <TableCell align="center">Item 2</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isFetching && (
              <TableRow>
                <TableCell colSpan={4}>Loading...</TableCell>
              </TableRow>
            )}

            {!isFetching && FetchConnections?.connections?.length > 0 ? (
              FetchConnections?.connections?.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">
                    <img
                      src={`${baseUrl}/g${
                        FetchItems?.find((item) => item._id == row.item1)
                          ?.frontViewImage
                      }`}
                      width={"150px"}
                      style={
                        {
                        }
                      }
                      alt="asdasd"
                    />
                  </TableCell>
                  <TableCell align="center">
                    {FetchItems?.find((item) => item._id == row.item1)?.name}
                  </TableCell>
                  <TableCell align="center">
                    <img
                      src={`${baseUrl}/g${
                        FetchItems?.find((item) => item._id == row.item2)
                          ?.frontViewImage
                      }`}
                      width={"150px"}
                      alt="asdasd"
                    />
                  </TableCell>
                  <TableCell align="center">
                    {FetchItems?.find((item) => item._id == row.item2)?.name}
                  </TableCell>
                  <TableCell align="center">
                    <>
                      <Tooltip title="Delete">
                        <IconButton
                          onClick={() => handleClickOpen(row._id)}
                          color="primary"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                      {open && selectedId === row?._id && (
                        <Dialog
                          maxWidth="sm"
                          fullWidth
                          open={open}
                          aria-labelledby="alert-dialog-title"
                          aria-describedby="alert-dialog-description"
                        >
                          <DialogTitle id="alert-dialog-title">
                            {"Confirm the Action?"}
                          </DialogTitle>
                          <Box position="absolute" top={10} right={0}>
                            <IconButton onClick={handleClose}>
                              <Close />
                            </IconButton>
                          </Box>
                          <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                              Do you really want to delete the item?
                            </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={handleClose} variant="outlined">
                              Cancel
                            </Button>
                            <Button
                              onClick={() => handleDelete(row._id)}
                              variant="contained"
                              autoFocus
                            >
                              Confirm
                            </Button>
                          </DialogActions>
                        </Dialog>
                      )}
                    </>
                    <ViewConnection
                      items={row}
                      item={FetchItems}
                      connectionPointsOptionsData={connectionPointsOptionsData}
                    />
                    <UpdateConnection
                      items={FetchItems}
                      item={row}
                      connectionPointsOptionsData={connectionPointsOptionsData}
                      connectionPointsData={connectionPointsData}
                    />
                  </TableCell>
                </TableRow>
              ))
            ) : !isFetching && FetchConnections?.connections.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4}>No Record !</TableCell>
              </TableRow>
            ) : null}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
